import { useToLocaleDayOfWeek } from "2g-intl";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "dayOfWeek",
  placeholderText: "monday",
  content: ({ val }) => useToLocaleDayOfWeek().long(val)
});
